import _JSXStyle from "styled-jsx/style";
import React from 'react';
import useTheme from '../use-theme';
import withDefaults from '../utils/with-defaults';
import clsx from '../utils/clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  autoMargin: false,
  justify: 'flex-start',
  noPadding: false,
  className: ''
};

const CardHeader = ({
  children,
  className,
  autoMargin,
  justify,
  noPadding,
  ...props
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs("div", { ...props,
    className: _JSXStyle.dynamic([["1342321190", [justify, theme.layout.gapHalf, theme.layout.gapHalf]]]) + " " + (props && props.className != null && props.className || clsx('card-header', {
      'auto-margin': autoMargin,
      'no-padding': noPadding
    }, className) || ""),
    children: [children, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1342321190",
      dynamic: [justify, theme.layout.gapHalf, theme.layout.gapHalf],
      children: `.card-header.__jsx-style-dynamic-selector{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;z-index:1;-webkit-box-pack:${justify};-webkit-justify-content:${justify};-ms-flex-pack:${justify};justify-content:${justify};-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden;color:inherit;font-size:0.875rem;padding:${theme.layout.gapHalf} calc(${theme.layout.gapHalf} + 0.25rem);}.no-padding.__jsx-style-dynamic-selector{padding:0;}.auto-margin.__jsx-style-dynamic-selector>*:first-child{margin-top:0;}.auto-margin.__jsx-style-dynamic-selector>*:last-child{margin-bottom:0;}`
    })]
  });
};

const MemoCardHeader = /*#__PURE__*/React.memo(CardHeader);
export default withDefaults(MemoCardHeader, defaultProps);